import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { ItemTypes } from './Constants';
import { DropTarget } from 'react-dnd';
import { ModalManager} from '../helpers/index';
import SpPageBuilderModal from '../helpers/modal';
import Addon from './Addon';
import InnerRow from './InnerRow';
import { saveSetting } from '../actions/index';

import EditPanelManager from '../helpers/EditPanelManager';

const addonListTarget = {
  /* hover(props, monitor, component) {
    const item          = monitor.getItem();
    const dragIndex     = item.index;
    const hoverIndex    = props.index;

    if(item.type == 'ADD_ADDON'){
      return;
    }

    if ( props.addons.length > 0 ) {
      return;
    }

    if ( props.rowIndex === item.rowIndex && props.colIndex === item.colIndex ) {
      return;
    }

    var options = {
      drag        : item,
      dragIndex   : dragIndex,
      drop        : props,
      hoverIndex  : hoverIndex
    };

    if (typeof item.innerRowIndex === 'undefined')
    {
      if ( props.rowIndex === item.rowIndex) {
        options.type = 'ADDON_SORT_COL';
      } else {
        options.type = 'ADDON_SORT_OUTER_ROW';
      }
    } else {
      if ( props.rowIndex === item.rowIndex) {
        options.type = 'ADDON_SORT_PARENT_COL';
      } else {
        options.type = 'ADDON_SORT_PARENT_OUTER_ROW';
      }
    }

    props.dropAddon( options );  // drop item

    monitor.getItem().index         = 0;
    monitor.getItem().innerRowId    = props.innerRowId;
    monitor.getItem().innerColId    = props.innerColId;
    monitor.getItem().rowIndex      = props.rowIndex;
    monitor.getItem().colIndex      = props.colIndex;
    monitor.getItem().innerRowIndex = props.innerRowIndex;
    monitor.getItem().innerColIndex = props.innerColIndex;
  }, */
  drop(props, monitor, component){
    const item          = monitor.getItem();

    if(item.type == 'ADD_ADDON' && monitor.isOver({ shallow: true })){

      return {
        type: 'addon',
        status: true,
        index: 0,
        dropPosition: 'top',
        rowIndex: props.rowIndex,
        colIndex: props.colIndex
      };
    } else if(monitor.isOver({ shallow: true })){
      const dragIndex     = item.index;
      const hoverIndex    = props.index;

      if ( props.addons.length > 0 ) {
        return;
      }

      if ( props.rowIndex === item.rowIndex && props.colIndex === item.colIndex ) {
        return;
      }

      var options = {
        drag        : item,
        dragIndex   : dragIndex,
        drop        : props,
        hoverIndex  : hoverIndex
      };

      if (typeof item.innerRowIndex === 'undefined')
      {
        if ( props.rowIndex === item.rowIndex) {
          options.type = 'ADDON_SORT_COL';
        } else {
          options.type = 'ADDON_SORT_OUTER_ROW';
        }
      } else {
        if ( props.rowIndex === item.rowIndex) {
          options.type = 'ADDON_SORT_PARENT_COL';
        } else {
          options.type = 'ADDON_SORT_PARENT_OUTER_ROW';
        }
      }

      props.dropAddon( options );  // drop item

      monitor.getItem().index         = 0;
      monitor.getItem().innerRowId    = props.innerRowId;
      monitor.getItem().innerColId    = props.innerColId;
      monitor.getItem().rowIndex      = props.rowIndex;
      monitor.getItem().colIndex      = props.colIndex;
      monitor.getItem().innerRowIndex = props.innerRowIndex;
      monitor.getItem().innerColIndex = props.innerColIndex;
    }
  }
};

class AddonList extends Component {
  render() {
    const { addons, column, rowIndex, colIndex, connectDropTarget, canDrop, isOver, isOverCurrent } = this.props;

    var addonsClass = "sp-pagebuilder-addons";

    // if ( isOver && addons.length < 1 ) {
    //   console.log('addonlist');
    // }

    if(!addons.length) {
      addonsClass = addonsClass + ' sp-pagebuilder-no-addons';
    }

    if(isOverCurrent){
      addonsClass = addonsClass + ' sp-pagebuilder-show-placeholder';
    }

    return connectDropTarget(
      <div className={addonsClass}>
        {
          !(addons.length > 0) &&
          <div className="addon-placeholder-top"><i className="fa fa-sort" /></div>
        }

        {
          addons.length > 0
          ?
          <div>
            {addons.map( ( addon, index) =>
              addon.type === 'inner_row'
              ?
              <InnerRow
                key={addon.id}
                id={addon.id}
                rowIndex={rowIndex}
                colIndex={colIndex}
                data={addon}
                index={index}
                addonSort={ this.props.addonSortable }
                />
              :
              <Addon
                key={ addon.id }
                id={ addon.id }
                rowIndex={ rowIndex }
                addon={ addon }
                column={ column }
                colIndex={ colIndex }
                index={ index }
                addonSort={ this.props.addonSortable }
                columnMove={ this.props.moveButton }
                />
            )}
          </div>
          :
          <span className="sp-pagebuilder-add-addon-empty" onClick={e => {
            EditPanelManager.resetAll();
            }}><i className="pbfont pbfont-plus"></i></span>
        }
      </div>
    )
  }
}

var DropTargetDecorator = DropTarget( [ ItemTypes.ADDON, ItemTypes.INNERROW, ItemTypes.INNERADDON ], addonListTarget,
  function( connect, monitor ) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      isOverCurrent: monitor.isOver({ shallow: true })
    };
  }
);

const mapStateToProps = ( state ) => {
  return {
    state: state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addonSortable : ( options ) => {
      dispatch(options);
    },
    onSettingsClick: (options) => {
      dispatch(saveSetting(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropTargetDecorator(AddonList));



// WEBPACK FOOTER //
// ./src/components/AddonList.js